import {
  SetupOrgOnboardingSteps,
  BusinessCategory,
  ToastBusinessCategory,
} from '@sdk/authentication/types';

export const DEFAULT_STEPS_PATH = [
  SetupOrgOnboardingSteps.account,
  SetupOrgOnboardingSteps.positions,
  SetupOrgOnboardingSteps.employees,
];

export const EMPLOYEES_COUNT_OPTIONS = [
  { label: '1 - 20', value: '1 - 20' },
  { label: '21 - 50', value: '21 - 50' },
  { label: '51 - 100', value: '51 - 100' },
  { label: '101 - 250', value: '101 - 250' },
  { label: '251 - 500', value: '251 - 500' },
  { label: '501 or more', value: '501 or more' },
];

export const OTHER_BUSINESS_CATEGORY = 'Other';
export const BUSINESS_CATEGORIES_OPTIONS = Object.values(BusinessCategory).map((o) => ({
  label: o,
  value: o,
}));

export const TOAST_BUSINESS_CATEGORIES_OPTIONS = Object.values(ToastBusinessCategory).map((o) => ({
  label: o,
  value: o,
}));

export const DEFAULT_POSITIONS = [
  'Server',
  'Bartender',
  'Manager',
  'Host',
  'Dishwasher',
  'Assistant manager',
];

export const INDUSTRY_POSITIONS = {
  [BusinessCategory.healthcare]: [
    'Nurse',
    'Physician',
    'Physical therapist',
    'Counselor',
    'Technologist',
    'Physician assistant',
  ],
  [BusinessCategory.retail]: [
    'Sales associate',
    'Cashier',
    'Store manager',
    'Cleaner',
    'Merchandiser',
    'Maintenance',
  ],
  [BusinessCategory.transportation]: [
    'Driver',
    'Operations manager',
    'Coordinator',
    'Expeditor',
    'Logistics manager',
    'Traffic supervisor',
  ],
};

export const TOAST_ONBOARDING_CATEGORIES = [
  ToastBusinessCategory.bar,
  ToastBusinessCategory.cafe,
  ToastBusinessCategory.catering,
  ToastBusinessCategory.coffeeShop,
  ToastBusinessCategory.foodTruck,
  ToastBusinessCategory.hotel,
  ToastBusinessCategory.restaurant,
];
